import React, { useCallback, useEffect, useState } from 'react';
import { Box, Fade, Modal, Typography } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import { historyHeader, global, sip } from "../translate";
import Api from "../Api";
import { toast } from "react-toastify";

import { style } from "../helpers/style";
import Utils from '../Utils';
export default function CustomCrm({ open, setCurrent, setCrms, setOpen }) {
    useEffect(() => {
        setOpen(prev => {
            if(prev.edit){
                const jsonString = String.fromCharCode(...open.access_actions.data);
                const jsonData = JSON.parse(jsonString);
                return {...prev,...jsonData}
            }
            else{
                return prev
            }
        })
    }, [])

    const handleChanges = (name, ev) => {
        setOpen(prev => ({
            ...prev,
            [name]: ev
        }))
    }
    const handleAdd = async () => {
        if (open.edit) {
            const { data } = await Api.editCustomCrm(open)
            setCrms(data.data)
            setCurrent({
                id: 0,
                sip: '',
                crmid: '',
                params: '',
            })
            setOpen({
                visible: false,
                end: false,
                startend: false,
                startStatus: false
            })
            toast.success(global.success[+localStorage.getItem('atsLang')])
        } else {
            const { data } = await Api.createCustomCrm(open)
            setCrms(data.data)
            toast.success(global.create[+localStorage.getItem('atsLang')])
            setOpen({
                visible: false,
                end: false,
                startend: false,
                startStatus: false
            })
        }

    }
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={!!open}
            onClose={() => {
                setOpen({
                    visible: false,
                    end: false,
                    startend: false,
                    startStatus: false
                })
            }}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={!!open.visible}>
                <Box sx={style}>
                    <div className="d-flex justify-content-between">
                        <div><span style={{ marginRight: 10 }}>Զանգի ավարտ և սկիզբ</span>
                            <input type="checkbox" checked={open.startend}
                                onChange={(ev) => handleChanges("startend", +ev.target.checked)} /></div>
                        <div><span style={{ marginRight: 10 }}>Զանգի ավարտ</span>
                            <input type="checkbox" checked={open.end}
                                onChange={(ev) => handleChanges("end", +ev.target.checked)} /></div>
                        <div><span style={{ marginRight: 10 }}>Զանգի սկիզբ ստատուս</span>
                            <input type="checkbox" checked={open.startStatus}
                                onChange={(ev) => handleChanges("startStatus", +ev.target.checked)} /></div>

                    </div>
                    <div>
                        <button onClick={handleAdd} className="addBtn" style={{ marginTop: 30 }}>
                            {global.edit[+localStorage.getItem('atsLang') || 1]}
                        </button>
                    </div>
                </Box>
            </Fade>
        </Modal>
    )
}
